import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import event from '~helpers/mixpanel';
import ResidentTypeItem from '~pages/onboarding/resident-type/item';

// keep the same with backend enum
const residentTypes = {
  STUDENT_ONLY: 'STUDENT_ONLY',
  ALL: 'ALL',
};

const useStyles = makeStyles(
  theme => ({
    wrap: {
      ...theme.flex.colCross,
      padding: '136px 0',
      position: 'relative',

      '& h2': {
        ...theme.typography.h2,
        margin: '0 0 48px 0',
      },
    },
    residentTypesWrap: {
      display: 'flex',
    },
  }),
  { name: 'ResidentType' },
);

const ResidentType = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    event('Viewed OP Resident Type Page');
  }, []);

  return (
    <div className={classes.wrap}>
      <h2>{t('landlord.onboarding.resident_type.title')}</h2>
      <div className={classes.residentTypesWrap}>
        <For each="residentType" of={Object.keys(residentTypes)} index="index">
          <ResidentTypeItem key={index} residentType={residentType} />
        </For>
      </div>
    </div>
  );
};

export default ResidentType;
